<template>
  <div>
    <div class="container start">
    <div class="pt-4">
    <div v-if="user===null" >
    <a href="/#/Login">Zum Login</a>
    </div>
    <div>
    <a href="/#/AuftragAnfrage">Zur Auftragserfassung</a>
    </div>
    </div>
  </div>
 </div>
</template>

<script>
export default {
  name: 'Start',
  beforeCreate () {
    document.body.className = ''
  },
  data () {
    return {
      user: this.$store.state.auth.user,
      msg: ''
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/Start.vue